/* esm.sh - @floating-ui/react-dom@2.1.8 */
export * from "/*@floating-ui/react-dom@2.1.8/esnext/react-dom.mjs";
